<script setup lang="ts">
import { computed } from 'vue'
import starterPackImage from '@/assets/images/shop.png'
import afterStarterPackImage from '@/assets/images/shop2.png'
import ShopBadge from '@/components/ShopBadge.vue'
import starterPackValueImage from '@/assets/images/shop-badge-1000.png'
import afterStarterPackValueImage from '@/assets/images/shop-badge-500.png'
import turboStarterPackValueImage from '@/assets/images/shop-badge-400.png'
import { useLimitedTimeOffers } from '@/composables/game/ecommerce'
import SparkIcon from '@/components/icons/SparkIcon.vue'
import { formatDuration } from '@/helpers/date'

const props = withDefaults(defineProps<{
  coolDown?: number
  label?: string
  labelClass?: string
  isStarter: boolean
}>(), {
  coolDown: 0,
  label: undefined,
  labelClass: '',
})

const { afterStarterPackDuration } = useLimitedTimeOffers()
const hasCooldown = computed(() => props.coolDown > 0)
const formattedTime = computed(() => formatDuration(afterStarterPackDuration.value - props.coolDown))
</script>

<template>
  <div class="relative h-[52px] w-[48px] translate-y-2">
    <ShopBadge
      :value-image="isStarter ? starterPackValueImage : (hasCooldown ? afterStarterPackValueImage : turboStarterPackValueImage)"
    />
    <SparkIcon
      class="absolute sparkling-star size-4"
    />
    <img
      class="size-[48px] object-cover"
      :src="isStarter ? starterPackImage : afterStarterPackImage"
    >
    <div
      v-if="hasCooldown || label"
      class="absolute left-1/2 -translate-x-1/2 h-[18px] px-1.5 top-[38px] rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-dark-top-most-layer"
    >
      <span
        v-if="hasCooldown"
        class="text-red-accent"
      >
        {{ formattedTime }}
      </span>
      <span
        v-else
        class="whitespace-nowrap"
      >
        {{ label }}
      </span>
    </div>
  </div>
</template>
<style scoped>
.sparkling-star {
  top: 4px;
  right: 4px;
  animation: sparkle 2.5s infinite;
  transition: all;
  transition-delay: 200ms;
}

@keyframes sparkle {
  0% {
    bottom: auto;
    left: auto;
    top: 4px;
    right: 4px;
    opacity: 1;
  }
  20% {
    bottom: auto;
    left: auto;
    top: 4px;
    right: 4px;
    opacity: 0;
  }
  35% {
    top: auto;
    right: auto;
    bottom: 4px;
    left: 4px;
    opacity: 0;
  }
  50% {
    top: auto;
    right: auto;
    bottom: 4px;
    left: 4px;
    opacity: 1;
  }
  70% {
    top: auto;
    right: auto;
    bottom: 4px;
    left: 4px;
    opacity: 0;
  }
  85% {
    bottom: auto;
    left: auto;
    top: 4px;
    right: 4px;
    opacity: 0;
  }
  100% {
    bottom: auto;
    left: auto;
    top: 4px;
    right: 4px;
    opacity: 1;
  }
}
</style>